import { useQuery } from "react-query";
import { getJSON } from "../api/http";
import { endpoints } from "../api/endpoints";

export interface IGponDevice {
    id: string;
    // serialnumber: string;
    // mac: string;
    // description: string;
    // creationdate: string;
    // blocked: string;
    // status: string;
    // rxpower: string;
    // deactivereason: string;
}

export interface IGponData {
    list: IGponDevice[];
    total: number;
}

export const restructureGponData = (gponData: IGponData) =>
    gponData
        ? gponData.list.map(
            ({/*  serialnumber, blocked, rxpower, deactivereason, creationdate, mac, description, status, */ id }) => ({
                /* serialNumber: serialnumber,
                isBlocked: blocked,
                receiverPower: rxpower,
                deactivateReason: deactivereason,
                creationDate: creationdate,
                macAddress: mac,
                description,
                status, */
                id,
            })
        )
        : [];

const getGponList = async () => getJSON(endpoints.devices.gpon.list);

export const useGponList = () => {
    const { data, isLoading, error } = useQuery(
        "gponList",
        getGponList,
        {
            staleTime: Infinity,
        }
    );

    return {
        isLoading,
        data: restructureGponData(data?.data),
        error,
    };
};
